import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Calendar, Clock, Palmtree, FileText } from 'lucide-react';

const features = [
  {
    icon: Calendar,
    title: 'Smart Scheduling',
    description: 'Build rosters faster and reduce scheduling conflicts with shift planning tools designed for team scheduling.',
  },
  {
    icon: Clock,
    title: 'Time & Attendance',
    description: 'Track clock-ins and attendance records with location-aware time tracking for reliable workforce records.',
  },
  {
    icon: Palmtree,
    title: 'Leave Management',
    description: 'Manage leave balances, approvals, and policies in one place.',
  },
  {
    icon: FileText,
    title: 'Payroll Ready',
    description: 'Keep workforce data organized and ready for payroll export and reporting workflows.',
  },
];

const FeaturesSection = () => {
  return (
    <section id="features" className="py-20 bg-muted/50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Everything you need to manage your team
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Built for hospitality, retail, and shift-based teams who need simplicity over complexity.
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature) => (
            <Card key={feature.title} className="border-0 shadow-sm">
              <CardHeader>
                <div className="h-12 w-12 rounded-lg bg-primary/10 flex items-center justify-center mb-4">
                  <feature.icon className="h-6 w-6 text-primary" />
                </div>
                <CardTitle className="text-xl">{feature.title}</CardTitle>
              </CardHeader>
              <CardContent>
                <CardDescription className="text-base">
                  {feature.description}
                </CardDescription>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
